export default {
  init() {
    const $selects = $('.variations select');

    $selects.each(function() {
      const $el = $(this);
      const $nextEl = $el.next();
      // If there isn't an element next to this then it's a select on it's own and not followed by custom radios.
      // Therefore it's just a single select that needs to be customised.
      if($nextEl.length == 0) {
        $el.wrap('<div class="custom-select"></div>');
      }
    })

  },
}


// WEBPACK FOOTER //
// ./scripts/components/custom-selects.js